import OfferList from "../../components/OfferList/OfferList";
import {useSelector} from "react-redux";
export default function Home({navigation, route}) {

    let user = useSelector(state=>state.user.user)
    let appData = useSelector(state=>state.appData.appData)

    if(appData){
        let category = null
        if(route.params.category){
            category = route.params.category
        }
        return (
            <OfferList
               appData={appData}
               navigation={navigation}
               previousScreen={'Home'}
               showSearch='true'
               category={category}
               user={user}
               favourites={false}
            />
        )
    } else {
        return (
            <></>
        )
    }
}